"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromoCardState = /** @class */ (function () {
    function PromoCardState() {
        this.displayGotPromoLink = true;
        this.isApplyBtnDisabled = true;
        this.isPromoError = false;
        this.isApplyRepBtnDisabled = true;
        this.isRepError = false;
        this.isRepErrorRemove = false;
        this.repErrTxt = 'Looks like that code either is invalid or has expired. Make sure you' +
            've entered it correctly and try again. (Promo codes are case sensitive.)';
        this.repCode = null;
        this.isRepCodeAvailable = false;
        this.isRepHardwareExists = false;
        this.promoErrTxt = '';
        this.promoCode = '';
        this.isHardwareExists = false;
        this.promoToggleOpen = false;
        this.couponCodeApplied = false;
    }
    return PromoCardState;
}());
exports.default = PromoCardState;
//# sourceMappingURL=PromoCardState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoCard/PromoCardState.js
// module id = 2244
// module chunks = 8